import React from 'react';
import { SwitchFieldBodyTimeSelect } from '../../styles';
import { VSwitchField } from 'welltrax-ui-components';
import { IFilterType } from '../../../../../../types/ProfileTypes';

interface ISwitchCustomTimeSelect {
  filter: IFilterType;
  isSpecific: boolean;
  onChange?: (value: any) => void;
  disabled?: boolean;
}

export const SwitchCustomTimeSelect = (props: ISwitchCustomTimeSelect) => {
  const { filter, isSpecific, onChange, disabled } = props;

  const createLabelOfState = (value: any): string => {
    switch (value) {
      case true:
        return filter?.booleanLabels ? filter?.booleanLabels['true'] : '';
      case false:
        return filter?.booleanLabels ? filter?.booleanLabels['false'] : '';
      case null:
        return filter?.booleanLabels && filter?.booleanLabels['null'] ? filter?.booleanLabels['null'] : '';
    }
    return '';
  };

  return (
    <SwitchFieldBodyTimeSelect>
      <VSwitchField id={'custom-time-select'} margin={'0'} {...{ onChange, disabled, value: isSpecific }} />
      <span className={'label-custom-time-select'}>{createLabelOfState(isSpecific)}</span>
    </SwitchFieldBodyTimeSelect>
  );
};
